import { render, staticRenderFns } from "./PosStarterCatalog.vue?vue&type=template&id=e833eb1a&scoped=true"
import script from "./PosStarterCatalog.vue?vue&type=script&lang=js"
export * from "./PosStarterCatalog.vue?vue&type=script&lang=js"
import style0 from "./PosStarterCatalog.vue?vue&type=style&index=0&id=e833eb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e833eb1a",
  null
  
)

export default component.exports